module.exports = __webpack_public_path__ + "2dd71fc7e9ac9c1a025f516e559dd965.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201610_Presse_AVANGA_DNN_193KB.jpg
// module id = 572
// module chunks = 0